<template>
   <div v-if="resultsLoaded">
      <results-header></results-header>
      <scroller>
        <results-content></results-content>
      </scroller>
   </div>
</template>

<script>
import ResultsHeader from '@/components/ResultsHeader.vue';
import ResultsContent from '@/components/ResultsContent.vue';
import Scroller from '@/components/Scroller.vue';
import format from 'date-fns/format';
import { toUTC } from '../helpers';
import { mapState } from 'vuex';

export default {
  name: 'results',
  components: {
    ResultsHeader,
    ResultsContent,
    Scroller,
  },
  computed: {
    ...mapState([
      'resultsLoaded',
    ]),
  },
  props: ['theme'],
  beforeCreate() {
    const dateFormat = 'yyyy-MM-dd HH:mm:ss';
    const d = new Date();
    const startDate = toUTC(new Date(d.setUTCHours(0, 0, 0)));
    const endDate = toUTC(new Date(d.setUTCHours(23, 59, 59)));

    this.$store.dispatch('FETCH_META', {
      start_date: startDate,
      end_date: endDate,
    });

    this.$store.dispatch('SAVE_DATE', startDate);

    this.$store.dispatch('FETCH_TRANSLATIONS');

    this.$store.watch(state => state.metaData, () => {
      const sports = this.$store.state.metaData.sports;
      this.$store.dispatch('SELECT_SPORT', sports[Object.keys(sports)[0]]);

      if (!this.$store.state.resultsLoaded) {
        this.$store.dispatch('FETCH_RESULTS', {
          start_date: startDate,
          end_date: endDate,
        });
      }
    });

    this.$store.watch(state => state.matchesData, () => {
      this.$store.dispatch('FILTER_SELECTION');
    });

    // SET THEME
    document.body.className = this.$options.propsData.theme;
  },
};
</script>
